import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import ThemePreset from './prime-vue-theme';

export default function SetupPrimeVue(app) {
  app
    .use(PrimeVue, {
      theme: {
        preset: ThemePreset,
        options: {
          darkModeSelector: '.dark-mode', // Disables dark-mode
        },
      },
      ripple: true,
    })
    .use(ConfirmationService)
    .use(DialogService)
    .use(ToastService)
    .directive('tooltip', Tooltip);

  return app;
}
